module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "college"
  }, [_c('div', [_vm._v("\n       \n      "), _c('el-button', {
    staticClass: "el-icon-plus buttonAdd",
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showDialog('new')
      }
    }
  }, [_vm._v(" 新增")])], 1), _vm._v(" "), _c('el-collapse', {
    staticClass: "collapse",
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, _vm._l((_vm.collegeList), function(college) {
    return _c('el-collapse-item', {
      key: college.id,
      staticClass: "collapseItem",
      attrs: {
        "title": college.name,
        "name": college.id
      }
    }, _vm._l((college.category), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "collapse-item-div",
        on: {
          "click": function($event) {
            return _vm.showDialog(college.id, item)
          }
        }
      }, [_c('div', {
        staticStyle: {
          "display": "inline-block",
          "width": "30%"
        }
      }, [_vm._v("  " + _vm._s(item.title) + "  ")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "inline-block"
        }
      }, [_vm._v(" " + _vm._s(item.code) + "  ")])])
    }), 0)
  }), 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "編輯學院主題分類",
      "show-close": false,
      "visible": _vm.dialogFormVisible,
      "customClass": "dialogWidth"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "隸屬學院",
      "prop": "collegeId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "請選擇學院"
    },
    on: {
      "change": _vm.collegeSel
    },
    model: {
      value: (_vm.selectedCollege),
      callback: function($$v) {
        _vm.selectedCollege = _vm._n($$v)
      },
      expression: "selectedCollege"
    }
  }, _vm._l((_vm.collegeList), function(college) {
    return _c('el-option', {
      key: college.id,
      attrs: {
        "label": college.name,
        "value": college.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "類別名稱",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "類別名稱縮寫",
      "prop": "code"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.code),
      callback: function($$v) {
        _vm.$set(_vm.form, "code", $$v)
      },
      expression: "form.code"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.isEdit) ? _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.deleteCategory
    }
  }, [_vm._v("刪除分類")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.isEdit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editCategory
    }
  }, [_vm._v("儲存")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addCategory
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b17b246"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/College.vue
// module id = 929
// module chunks = 170